<!-- 客户列表 -->
<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem; margin-bottom: 0!important;">
		<!-- 头部标签页 -->
		<el-tabs>
			<el-tab-pane label="全部"></el-tab-pane>
		</el-tabs>
		<!-- 客户列表 -->
		<el-table :data="tableData" style="width: 100%" border class="mt-3">
			<!-- 多选 -->
			<el-table-column type="selection" width="45" align="center">
			</el-table-column>

			<el-table-column align="center" label="客户姓名" width="150">
				<template slot-scope="scope">
					<span>{{scope.row.name}}</span>
				</template>
			</el-table-column>

			<el-table-column align="center" label="联系方式" width="220">
				<template slot-scope="scope">
					<span>{{scope.row.phone}}</span>
				</template>
			</el-table-column>

			<el-table-column width="220" align="center" label="微信号">
				<template slot-scope="scope">
					<span>{{scope.row.weixin}}</span>
				</template>
			</el-table-column>

			<!-- 配送方式 -->
			<el-table-column align="center" label="QQ号" width="220">
				<template slot-scope="scope">
					<span>{{scope.row.qq}}</span>
				</template>
			</el-table-column>

			<!-- 交易状态 -->
			<el-table-column align="center" width="630" label="客户需求">
				<template slot-scope="scope">
					<div>需求:
						<span>{{scope.row.title}}</span>
					</div>
				</template>
			</el-table-column>

			<!-- 操作 -->
			<el-table-column align="center" label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="mini" @click="deletes(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

	</div>
</template>

<script>
	import common from "@/common/mixins/common.js" // 引入 全局公共样式
	export default {
		inject: ['layout'],
		mixins: [common], // 引入mixins里的common.js
		data() {
			return {
				tableData: [],
			}
		},
		// 生命周期
		created() {
			this.getlist()
		},
		// 生命周期监听页面
		methods: {
			getlist(){
				this.axios.get('/admin/weixin', {
					token: true
				}).then(res => {
					this.tableData = res.data.data
				})
			},
			deletes(e){
				this.axios.delete('/admin/weixin/'+e, {
					token: true
				}).then(res => {
					this.getlist()
				})
			}
		}
	}
</script>

<style>
</style>
